//
// validation puis envoi des formulaires ayant la classe "ani-form"
//
let formSubmits			= document.querySelectorAll('form.ani-form button[type=submit]');

formSubmits.forEach(formSubmit => {
	formSubmit.addEventListener('click', function(event) {
		let form		= formSubmit.closest('form');

		if(!form.classList.contains('validated')) {
			event.preventDefault();

			if(form.checkValidity()) {
				if(document.querySelector('body').classList.contains('local') || !form.classList.contains('form-recaptcha')) {
					form.classList.add('validated');
					formSubmit.click();
				} else {
					if(form.querySelector('.response')) {
						grecaptcha.enterprise.ready(() => {
							grecaptcha.enterprise.execute('6LestBArAAAAAPLCwaGS_LTQb-5q6oePT6Oq8ftT', {
								action: 'submit'
							}).then(token => {
								document.querySelector('.response').value = token;
								form.submit();
							});
						});
					} else {
						form.classList.add('validated');
						formSubmit.click();
					}
				}
			} else {
				form.classList.add('was-validated');
			}
		}
	});
});